// src/pages/Kerjaya.jsx
import { useState } from "react";

import { dbWeb, storageWeb } from "../firebaseConfig";
import { addDoc, collection, serverTimestamp, updateDoc, doc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

import "../styles/Pengenalan.css";
import "../styles/Kerjaya.css";

import {
    FiGrid,
    FiCode,
    FiPenTool,
    FiHeadphones,
    FiBookOpen,
    FiUsers,
} from "react-icons/fi";


const MAX_PHOTO_MB = 3;

const initialForm = {
    namaPenuh: "",
    alamat: "",
    status: "",
    telefon: "",
    email: "",
    tarikhLahir: "",
    pendidikan: "",
    bidang: "",
    pengalaman: "",
    kenapaBerminat: "",
    kemahiran: "",
    gaji: "",
    jenisKerja: "Full-time",
    pautanPortfolio: "",
    persetujuan: false,
};

export default function Kerjaya() {
    const [form, setForm] = useState(initialForm);
    const [photoFile, setPhotoFile] = useState(null); // wajib
    const [submitting, setSubmitting] = useState(false);
    const [submittedId, setSubmittedId] = useState("");

    const setField = (k, v) => setForm((p) => ({ ...p, [k]: v }));

    const validate = () => {
        const required = [
            ["namaPenuh", "Nama penuh"],
            ["alamat", "Alamat"],
            ["status", "Status"],
            ["telefon", "No telefon"],
            ["email", "Email"],
            ["tarikhLahir", "Tarikh lahir"],
            ["pendidikan", "Pendidikan"],
            ["kenapaBerminat", "Kenapa berminat"],
            ["kemahiran", "Kemahiran"],
            ["gaji", "Jangkaan gaji"],
        ];

        for (const [k, label] of required) {
            if (!String(form[k] || "").trim()) return `${label} wajib diisi.`;
        }

        if (!photoFile) return "Gambar wajib diupload.";

        if (!form.persetujuan) {
            return "Sila tandakan persetujuan untuk kami simpan maklumat permohonan.";
        }

        if (!String(form.email).includes("@")) return "Email tidak sah.";

        if (photoFile && photoFile.size > MAX_PHOTO_MB * 1024 * 1024) {
            return `Saiz gambar terlalu besar. Maksimum ${MAX_PHOTO_MB}MB.`;
        }

        return "";
    };

    const onSubmit = async (e) => {
        e.preventDefault();

        const err = validate();
        if (err) {
            alert(err);
            return;
        }

        try {
            setSubmitting(true);

            // 1) create doc dulu
            const docRef = await addDoc(collection(dbWeb, "career_applications"), {
                ...form,
                gaji: String(form.gaji).trim(),
                telefon: String(form.telefon).trim(),
                email: String(form.email).trim().toLowerCase(),
                createdAt: serverTimestamp(),
                statusPermohonan: "new",
                photoUrl: "",
            });

            const id = docRef.id;

            // 2) upload photo (wajib)
            const photoExt = (photoFile.name.split(".").pop() || "jpg").toLowerCase();
            const photoPath = `career_applications/${id}/photo.${photoExt}`;
            const photoRef = ref(storageWeb, photoPath);

            await uploadBytes(photoRef, photoFile, {
                contentType: photoFile.type || "image/jpeg",
            });

            const photoUrl = await getDownloadURL(photoRef);

            // 3) update doc dengan URL
            await updateDoc(doc(dbWeb, "career_applications", id), { photoUrl });

            setSubmittedId(id);
            setForm(initialForm);
            setPhotoFile(null);

            alert("Permohonan berjaya dihantar!");
        } catch (error) {
            console.error("Kerjaya submit error:", error);
            alert("Maaf, permohonan gagal dihantar. Cuba lagi.");
        } finally {
            setSubmitting(false);
        }
    };

    // ✅ SUCCESS PAGE (ikut style Pengenalan)
    if (submittedId) {
        return (
            <div className="pg-wrap">
                <div className="container pg-container">
                    <div className="pg-section">
                        <div className="pg-section-title">
                            <span className="pg-kicker">Berjaya</span>
                            <h2 className="pg-h2">Permohonan Berjaya Dihantar</h2>
                            <p className="pg-desc">
                                Terima kasih. Permohonan anda telah direkodkan.
                            </p>
                        </div>

                        <div className="pg-showcase">
                            <div className="pg-showcase-head">
                                <div className="pg-showcase-title">Langkah seterusnya</div>
                                <div className="pg-showcase-sub">
                                    Jika sesuai, pihak <b>admin@etikaf.com</b> akan hubungi melalui email atau telefon.
                                </div>
                            </div>

                            <div className="pg-showcase-box">
                                <div className="pg-showcase-content">
                                    <div className="pg-showcase-row">
                                        Rujukan permohonan: <b style={{ marginLeft: 8 }}>{submittedId}</b>
                                    </div>



                                    <div className="pg-hero-actions" style={{ marginTop: 14 }}>

                                        <a className="pg-btn pg-btn-ghost" href="/">
                                            Kembali ke Laman Utama
                                        </a>
                                    </div>
                                </div>

                                <div className="pg-showcase-blob" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // ✅ MAIN PAGE
    return (
        <div className="pg-wrap">
            <div className="container pg-container">
                <div className="pg-hero">
                    {/* LEFT */}
                    <div>
                        <h1 className="pg-h1">Kerjaya</h1>

                        <p className="pg-lead">
                            Kerja dakwah sangat luas. Dakwah hari ini bukan hanya di mimbar — ia bergerak melalui pelbagai jalan: pengurusan yang kemas, kandungan yang menyentuh hati, komunikasi yang jelas, khidmat yang memudahkan urusan masyarakat, serta usaha berterusan yang menghidupkan suasana masjid dan komuniti.
                            <br /><br />
                            Di Etikaf, kita sedang mengumpulkan satu pasukan yang mahu menyumbang dalam kerja dakwah mengikut kemampuan masing-masing. Ada yang kuat pada perancangan dan operasi, ada yang mahir menghasilkan kandungan, ada yang pandai berhubung dengan orang ramai, ada yang kreatif dengan reka bentuk dan video, dan ada juga yang minat membina sistem serta memperkemas proses. Matlamatnya satu: membantu masjid dan masyarakat bergerak dengan lebih tersusun, cepat, dan berkesan — supaya kebaikan lebih mudah sampai, lebih mudah diikuti, dan lebih mudah dikekalkan.
                        </p>



                    </div>

                    {/* RIGHT */}
                    <div className="pg-side-card" id="info">
                        <div className="pg-side-head">
                            <div className="pg-side-ic">
                                <FiGrid />
                            </div>
                            <div>
                                <div className="pg-side-title">Bidang Kerjaya</div>
                                <div className="pg-side-sub">
                                    Kami perlukan pelbagai peranan
                                </div>
                            </div>
                        </div>

                        <div className="pg-side-body">
                            <div className="pg-side-mini">
                                <div className="pg-mini-row">
                                    <FiCode /> <span>Teknologi & Produk</span>
                                </div>

                                <div className="pg-mini-row">
                                    <FiPenTool /> <span>Rekabentuk & Multimedia </span>
                                </div>

                                <div className="pg-mini-row">
                                    <FiHeadphones /> <span>Operasi & Sokongan </span>
                                </div>

                                <div className="pg-mini-row">
                                    <FiBookOpen /> <span>Kandungan Dakwah </span>
                                </div>

                                <div className="pg-mini-row">
                                    <FiUsers /> <span>Jaringan & Kerjasama</span>
                                </div>
                            </div>

                            <div className="pg-note">
                                Jika anda berminat menyumbang dalam mana-mana bidang di atas, isi borang permohonan.
                                Kami akan semak dan jika sesuai, kami akan menghubungi anda
                            </div>
                        </div>
                    </div>

                </div>

                {/* FORM SECTION */}
                <div className="pg-section" id="borang-kerjaya">
                    <div className="pg-section-title">
                        <span className="pg-kicker">Permohonan</span>
                        <h2 className="pg-h2">Bekerjaya Bersama Etikaf</h2>
                        <p className="pg-desc">Lokasi kerja: Cyberjaya (hybrid) atau remote dari rumah — ikut peranan dan keperluan semasa. </p>
                    </div>

                    <div className="pg-form-wrap">
                        <form onSubmit={onSubmit} className="pg-form-grid">
                            {/* Nama */}
                            <div className="pg-field">
                                <div className="pg-label">Nama penuh <span className="req">*</span></div>
                                <input
                                    className="pg-input"
                                    value={form.namaPenuh}
                                    onChange={(e) => setField("namaPenuh", e.target.value)}
                                />
                            </div>

                            {/* Telefon */}
                            <div className="pg-field">
                                <div className="pg-label">No telefon <span className="req">*</span></div>
                                <input
                                    className="pg-input"
                                    value={form.telefon}
                                    onChange={(e) => setField("telefon", e.target.value)}
                                />
                            </div>

                            {/* Email */}
                            <div className="pg-field">
                                <div className="pg-label">Email <span className="req">*</span></div>
                                <input
                                    className="pg-input"
                                    type="email"
                                    value={form.email}
                                    onChange={(e) => setField("email", e.target.value)}
                                />
                            </div>

                            {/* Status */}
                            <div className="pg-field">
                                <div className="pg-label">Status <span className="req">*</span></div>
                                <select
                                    className="pg-select"
                                    value={form.status}
                                    onChange={(e) => setField("status", e.target.value)}
                                >
                                    <option value="">Pilih</option>
                                    <option value="Bujang">Bujang</option>
                                    <option value="Berkahwin">Berkahwin</option>
                                </select>
                            </div>

                            {/* Tarikh Lahir */}
                            <div className="pg-field">
                                <div className="pg-label">Tarikh lahir <span className="req">*</span></div>
                                <input
                                    className="pg-input"
                                    type="date"
                                    value={form.tarikhLahir}
                                    onChange={(e) => setField("tarikhLahir", e.target.value)}
                                />
                            </div>

                            {/* Jenis Kerja */}
                            <div className="pg-field">
                                <div className="pg-label">Pilihan kerja</div>
                                <select
                                    className="pg-select"
                                    value={form.jenisKerja}
                                    onChange={(e) => setField("jenisKerja", e.target.value)}
                                >
                                    <option value="Full-time">Full-time</option>
                                    <option value="Part-time">Part-time</option>
                                    <option value="Freelance">Freelance</option>
                                    <option value="Intern">Intern</option>
                                </select>
                            </div>

                            {/* Pendidikan */}
                            <div className="pg-field">
                                <div className="pg-label">Pendidikan <span className="req">*</span></div>
                                <input
                                    className="pg-input"
                                    value={form.pendidikan}
                                    onChange={(e) => setField("pendidikan", e.target.value)}
                                />
                            </div>

                            {/* Bidang */}
                            <div className="pg-field">
                                <div className="pg-label">Bidang</div>
                                <input
                                    className="pg-input"
                                    value={form.bidang}
                                    onChange={(e) => setField("bidang", e.target.value)}
                                />
                            </div>

                            {/* Alamat */}
                            <div className="pg-field pg-field-wide">
                                <div className="pg-label">Alamat <span className="req">*</span></div>
                                <textarea
                                    className="pg-textarea"
                                    rows={3}
                                    value={form.alamat}
                                    onChange={(e) => setField("alamat", e.target.value)}
                                />
                            </div>

                            {/* Pengalaman */}
                            <div className="pg-field pg-field-wide">
                                <div className="pg-label">Pengalaman kerja</div>
                                <textarea
                                    className="pg-textarea"
                                    rows={3}
                                    value={form.pengalaman}
                                    onChange={(e) => setField("pengalaman", e.target.value)}
                                />
                            </div>

                            {/* Kenapa berminat */}
                            <div className="pg-field pg-field-wide">
                                <div className="pg-label">Kenapa berminat bersama Etikaf? <span className="req">*</span></div>
                                <textarea
                                    className="pg-textarea"
                                    rows={4}
                                    value={form.kenapaBerminat}
                                    onChange={(e) => setField("kenapaBerminat", e.target.value)}
                                />
                            </div>

                            {/* Kemahiran */}
                            <div className="pg-field pg-field-wide">
                                <div className="pg-label">Apa kemahiran utama anda? <span className="req">*</span></div>
                                <textarea
                                    className="pg-textarea"
                                    rows={4}
                                    value={form.kemahiran}
                                    onChange={(e) => setField("kemahiran", e.target.value)}
                                />
                            </div>

                            {/* Portfolio */}
                            <div className="pg-field ">
                                <div className="pg-label">Pautan portfolio (jika ada)</div>
                                <input
                                    className="pg-input"
                                    value={form.pautanPortfolio}
                                    onChange={(e) => setField("pautanPortfolio", e.target.value)}
                                />


                            </div>

                            {/* Gaji + Lokasi */}
                            <div className="pg-field">
                                <div className="pg-label">Jangkaan gaji (RM) <span className="req">*</span></div>
                                <input
                                    className="pg-input"
                                    value={form.gaji}
                                    onChange={(e) => setField("gaji", e.target.value)}
                                />
                            </div>



                            {/* Upload photo */}
                            <div className="pg-field pg-field-wide">
                                <div className="pg-label">Upload gambar <span className="req">*</span></div>
                                <div className="pg-file">
                                    <input
                                        type="file"
                                        accept="image/*"
                                        onChange={(e) => setPhotoFile(e.target.files?.[0] || null)}
                                    />
                                    <div className="pg-help">Gambar jelas (max {MAX_PHOTO_MB}MB).</div>
                                </div>
                            </div>

                            {/* Consent */}
                            <div className="pg-field pg-field-wide">
                                <label className="pg-consent">
                                    <input
                                        type="checkbox"
                                        checked={form.persetujuan}
                                        onChange={(e) => setField("persetujuan", e.target.checked)}
                                    />
                                    <span>
                                        Saya bersetuju maklumat ini disimpan untuk tujuan proses permohonan.
                                    </span>
                                </label>
                            </div>

                            {/* Submit */}
                            <div className="pg-field pg-field-wide">
                                <div className="pg-hero-actions" style={{ marginBottom: 0 }}>
                                    <button
                                        type="submit"
                                        className="pg-btn pg-btn-primary"
                                        disabled={submitting}
                                    >
                                        {submitting ? "Menghantar..." : "Hantar Permohonan"}
                                    </button>


                                </div>


                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}
